import "../../styles/index.css"
import "./Pesquisa.css"
import CardProduto from "../../components/Cards/CardProduto/CardProduto"
import ImagemExemplo from "../../assets/img/Imagem Exemplo.png"
import BotaoFiltros from "../../components/Buttons/BotaoFiltros/BotaoFiltros"
import OrdenarPor from "../../components/Buttons/OrdenarPor/OrdenarPor"
import Location from "../../components/Location/Location"
import MenuFiltros from "../../components/Menus/MenuFiltros/MenuFiltros"
import ModalNotificar from "../../components/Modals/ModalNotificar/ModalNotificar"
import { useState, useEffect, useRef } from "react"
import CustomButton from "../../components/Buttons/CustomButton/CustomButton"
import { useParams, useSearchParams } from "react-router-dom"
import { apiSearch, apiCategorias } from "../../api/api"
import { filtros, ordemCrescente, ordemDecrescente, filtrandoPeloSlider } from "../../utils/filtros"
import { categoryFromAPI } from "../../utils/categoryFromAPI"
import Spinner from "../../components/Spinner/Spinner"

function Pesquisa() {
	const [searchParams, setSearchParams] = useSearchParams()
	const { pesquisa } = useParams()
	const produtos = useRef([])
	const filterKeys = useRef([])
	const [produtosEmTela, setProdutosEmTela] = useState([])
	const [preçoProdutoDesejado, setPreçoProdutoDesejado] = useState([])
	const [idProdutoDesejado, setIdProdutoDesejado] = useState([])
	const [titulos, setTitulos] = useState([])
	const [filters, setFilters] = useState([])
	const [loaded, setLoaded] = useState(false)
	const filtersToFetch = useRef({})
	const [ordenarPor, setOrdenarPor] = useState("Menor")
	const itensPorPagina = 8

	useEffect(() => {
		setOrdenarPor("Menor")
		filtersToFetch.current = {}
		setLoaded(false)

		if (Object.keys(categoryFromAPI).includes(pesquisa)) {
			setTitulos(filtros[pesquisa])

			apiCategorias.listaFiltrosCategoria(pesquisa).then((response) => {
				console.log("Filtros da API: ", response)

				if (!response.message) {
					filterKeys.current = Object.keys(response)
					setFilters(Object.values(response))
				} else {
					filterKeys.current = Object.keys([])
					setFilters(Object.values([]))
				}
			})

			apiCategorias.listaProdutos(pesquisa).then((response) => {
				const produtosDisponiveis = adicionaProdutosDisponiveis(response)

				produtos.current = produtosDisponiveis

				aplicaFiltros()

				setProdutosEmTela(produtos.current.slice(0, itensPorPagina))
				setLoaded(true)
			})
		} else {

			apiSearch.pesquisaProdutos(pesquisa).then((response) => {
				const produtosDisponiveis = adicionaProdutosDisponiveis(response)

				produtos.current = produtosDisponiveis

				filterKeys.current = Object.keys([])
				setFilters(Object.values([]))
				aplicaFiltros()

				setProdutosEmTela(produtos.current.slice(0, itensPorPagina))
				setLoaded(true)
			})

		}

	}, [pesquisa, searchParams])

	const aplicaFiltros = () => {
		filterKeys.current.forEach((key) => {
			const filterData = searchParams.getAll(key)

			if (filterData.length > 0) {
				filtersToFetch.current[key] = filterData
			}
		})

		console.log("filtersToFetch.current", filtersToFetch.current)

		if (Object.keys(filtersToFetch.current).length > 0) {
			apiCategorias
				.filtrarCategoria(pesquisa, filtersToFetch.current)
				.then((response) => {
					if (!response.message) {
						console.log("Resposta da API filtro: ", response)
						filterKeys.current = Object.keys(response["filters_values"])
						setFilters(Object.values(response["filters_values"]))

						const produtosDisponiveis = adicionaProdutosDisponiveis(
							response["products"]
						)

						produtos.current = produtosDisponiveis

						if (searchParams.get("min") && searchParams.get("max")) {
							produtos.current = filtrandoPeloSlider(
								searchParams.get("min"),
								searchParams.get("max"),
								produtos.current
							)
						}

						setProdutosEmTela(produtos.current.slice(0, itensPorPagina))
					} else {
						// filterKeys.current = Object.keys([])
						// setFilters(Object.values([]))
						console.log("Resposta da API filtro: ", response)
						produtos.current = []
						setProdutosEmTela([])
					}
				})
		} else {
			if (searchParams.get("min") && searchParams.get("max")) {
				produtos.current = filtrandoPeloSlider(
					searchParams.get("min"),
					searchParams.get("max"),
					produtos.current
				)
			}

			setProdutosEmTela(produtos.current.slice(0, itensPorPagina))
		}
	}

	const adicionaProdutosDisponiveis = (response) => {
		console.log("Resposta da API: ", response)

		let produtosDisponiveis = []

		if (!response['products']) {
			produtosDisponiveis = response
		} else {

			if (response.products.constructor !== Object) {
				produtosDisponiveis = response.products
			} else {
				Object.values(response.products).forEach((values) => {

					produtosDisponiveis = produtosDisponiveis.concat(values)

				})
			}

		}

		ordemCrescente(produtosDisponiveis)

		console.log("Produtos disponiveis: ", produtosDisponiveis)

		return produtosDisponiveis
	}

	const mostrarMaisProdutos = () => {
		setProdutosEmTela([
			...produtosEmTela,
			...produtos.current.slice(
				produtosEmTela.length,
				produtosEmTela.length + itensPorPagina
			),
		])
	}

	const ordenarPreço = () => {
		const produtosCopy = [...produtos.current]

		if (ordenarPor === "Menor") {
			setOrdenarPor("Maior")
			ordemDecrescente(produtosCopy)
		}

		if (ordenarPor === "Maior") {
			setOrdenarPor("Menor")
			ordemCrescente(produtosCopy)
		}

		produtos.current = produtosCopy
		setProdutosEmTela(produtosCopy.slice(0, itensPorPagina))
	}
	return (
		<>
			<ModalNotificar preçoAtual={preçoProdutoDesejado} categoria={pesquisa} productID={idProdutoDesejado} />

			<MenuFiltros
				titulos={titulos}
				filtros={filters}
				filterKeys={filterKeys.current}
			/>

			<main className="pesquisa page-container">
				<section>

					<Location local="Pesquisa" subLocal={pesquisa} />

					<div className="filtragem">
						<BotaoFiltros />

						<OrdenarPor ordem={ordenarPor} onClick={ordenarPreço} />
					</div>

				</section>

				<section className="secaoProdutosListados">

					{
						!loaded ? <Spinner /> : <>

							{
								produtos.current.length !== 0 ? <p className="b2 my-3 align-self-start">
									<span className="negrito">{produtos.current.length}</span> produtos encontrados
								</p> : <p className="b2 my-3 align-self-center">
									<span className="negrito">{produtos.current.length}</span> produtos encontrados
								</p>
							}

							<div className="cards-listados-pesquisa">

								{

									produtosEmTela.map((produto) => {

										const lojas = produto.stores

										const preços = []
										const preçosParcelado = []
										let qtdOfertas = 0

										lojas.forEach((loja) => {
											if (loja.stock_available === true) {
												preços.push(parseFloat(loja.spot_price))
												preçosParcelado.push(loja.foward_price)
												qtdOfertas += 1
											}
										})

										const preço = Math.min(...preços)
										const preçoParcelado = preçosParcelado[preços.indexOf(preço)]

										const preçoFormatado = preço.toString()

										const foto =
											produto["images"].length !== 0
												? produto["images"][0]
												: ImagemExemplo

										return (
											produto && (
												<CardProduto
													key={produto["id"]}
													imagem={foto}
													nome={produto["name"]}
													preço={preçoFormatado}
													preçoParcelado={preçoParcelado}
													qtdOfertas={qtdOfertas}
													categoria={pesquisa}
													id={produto["id"]}
													setPreçoProdutoDesejado={setPreçoProdutoDesejado}
													setIdProdutoDesejado={setIdProdutoDesejado}
												/>
											)
										)
									})

								}

							</div>

							<div className="btnVerMaisOfertas">

								{
									produtosEmTela.length < produtos.current.length && <CustomButton texto={"Ver mais ofertas"} cor={"white"} onClick={mostrarMaisProdutos} tipo={"1"} />
								}

							</div>

						</>

					}

				</section>

			</main >
		</>
	)
}

export default Pesquisa
